// 官方术语库的 8 种语言。与翻译语言列表（zh-CN / esb / pt）无关，前后端各自硬编码同一份。
export const PRESET_TERM_LANGS = ['en', 'zh-Hans', 'ja', 'ko', 'de', 'fr', 'es', 'pt-BR'] as const
export type PresetTermLang = typeof PRESET_TERM_LANGS[number]

export const PRESET_TERM_LANG_I18N: Record<PresetTermLang, string> = {
  'en': 'preset_lang_en',
  'zh-Hans': 'preset_lang_zh_hans',
  'ja': 'preset_lang_ja',
  'ko': 'preset_lang_ko',
  'de': 'preset_lang_de',
  'fr': 'preset_lang_fr',
  'es': 'preset_lang_es',
  'pt-BR': 'preset_lang_pt_br',
}

/** 界面语言 → 默认源语言；不在 8 种里的（tw/ar/hi/id/itb/uk）默认 en */
const UI_TO_SOURCE: Record<string, PresetTermLang> = { zh: 'zh-Hans', 'zh-CN': 'zh-Hans', en: 'en', ja: 'ja', ko: 'ko', de: 'de', fr: 'fr' }

export function fallbackTargetLang(source: PresetTermLang): PresetTermLang {
  return source === 'en' ? 'zh-Hans' : 'en'
}

export function defaultPresetLangPair(uiLocale: string | undefined | null): { sourceLang: PresetTermLang; targetLang: PresetTermLang } {
  const sourceLang = UI_TO_SOURCE[String(uiLocale || '')] || 'en'
  return { sourceLang, targetLang: fallbackTargetLang(sourceLang) }
}
